/**
 * PreparedDropsDraftsList utils
 * For Media Devoted | Created By Ciro Autiero
 */

import { formatCost } from '@/lib/utils';

export function money(value: number): string {
  if (!Number.isFinite(value)) return '—';
  return formatCost(value);
}
